
<div>
    <d-contract-esc-edit
        v-model      = "edit"
        :contract-id = "contract ? contract.id : null"
        :company-id  = "contract && contract.company ? contract.company.id : null"
        @saved       = "onSaved"
    />

    <c-list-card
        :icon       = "icon"
        :background = "background"
        :height     = "110"
        @edit       = "onEdit"
        @selected   = "onSelect"
    >
        <template v-slot:title>
            <div>
                <span class="primary--text">
                    {{ contract.id }} Notruf
                </span>
            </div>
            <v-spacer></v-spacer>
            <company-tag
                :label="$t('msd.service.role.esc.label')"
                :active  ="contract.active"
                :company = "contract.company"
                :highlight = "company && contract.company.id === company.id"
            />
        </template>

        <template v-slot:subtitle>
            <div class="primary--text customer-name">
                {{ contract.customer ? contract.customer.name : ''}}
            </div>
        </template>

        <template v-slot:body>
            <p-contract-condition
                :contract = "contract"
            />
        </template>

        <template v-slot:footer>

        </template>
    </c-list-card>
</div>
